module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/phead5-13d9c3f2ea373b4d5a60d66389259062.jpg";